export default {
  shopTitle: '系统公告',
  allInfo: '所有',
  haveRead: '已读',
  unread: '未读',
  ShopNews: '店铺消息',
  infoTitle: '消息标题',
  infoContent: '消息内容',
  publishDate: '发布时间',
  messageId: '消息Id',
  title: '标题',
  content: '详情',
  delete: '删除',
  selectDate: '选择日期'
}
